import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LogoLinkedin = function LogoLinkedin(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({}, newProps), {}, {
    className: classNames('sol-illustration', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "logo.linkedin"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "logo-linkedin"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    d: "M29.3264 29.3332V29.332H29.3331V19.552C29.3331 14.7676 28.3031 11.082 22.7098 11.082C20.0209 11.082 18.2164 12.5576 17.4798 13.9565H17.402V11.5287H12.0986V29.332H17.6209V20.5165C17.6209 18.1954 18.0609 15.9509 20.9353 15.9509C23.7675 15.9509 23.8098 18.5998 23.8098 20.6654V29.3332H29.3264Z",
    fill: "#0077B5"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_2",
    d: "M3.10645 11.5312H8.63533V29.3346H3.10645V11.5312Z",
    fill: "#0077B5"
  }), /*#__PURE__*/React__default.createElement("path", {
    id: "Vector_3",
    d: "M5.86921 2.66797C4.10144 2.66797 2.66699 4.10241 2.66699 5.87019C2.66699 7.63797 4.10144 9.10241 5.86921 9.10241C7.63699 9.10241 9.07144 7.63797 9.07144 5.87019C9.07032 4.10241 7.63588 2.66797 5.86921 2.66797Z",
    fill: "#0077B5"
  }))));
};

export { LogoLinkedin };
